import { styled } from "@mui/material/styles";
import { Drawer, Stack } from "@mui/material";

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    width: "100%",
    maxWidth: "500px",
    overflow: "hidden",
  },
}));

export const StyledProgressBar = styled(Stack, {
  shouldForwardProp: (prop) => !["percent"].includes(prop),
})(({ theme, percent }) => ({
  width: "100%",
  height: "10px",
  borderRadius: "10px",
  background: `linear-gradient(to right, ${theme.palette.hubColors.mainFocus} ${percent}%, ${theme.palette.hubColors.mainFocusLight} ${percent}%)`,
}));
